import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/**
 * LOCAL_MODE only — injects the local JWT into every outgoing HTTP request
 * that targets the local gateway, in case a service didn't set it at
 * construction time (e.g. token was stored after the service was created).
 *
 * Registered in AppModule only when environment.localMode is true.
 */
@Injectable()
export class LocalAuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem(environment.keys.accessToken);

    // Normalize double slashes in the URL path (e.g. /api//seasons → /api/seasons)
    const normalizedUrl = req.url.replace(/([^:])\/\/+/g, '$1/');
    // Gate Bearer injection to environment.apiUrl — never leak the JWT to
    // third-party origins (CDN, accidental external call).
    const shouldAttachAuth = !!token && normalizedUrl.startsWith(environment.apiUrl);
    const cloned = req.clone({
      url: normalizedUrl,
      ...(shouldAttachAuth ? { setHeaders: { Authorization: `Bearer ${token}` } } : {}),
    });
    return next.handle(cloned);
  }
}
